const adminApps = {
  actions: {
    channels: '使用渠道',
    add: '添加应用',
    delete: '删除',
    edit: '编辑',
    im: 'IM对接',
    members: '成员管理',
    open: '打开 {{name}} 的操作菜单',
  },
  channels: {
    title: '使用渠道',
    description:
      '选择已获得应用使用权限的用户可以在哪些平台看到并使用此应用。平台开关不会扩大使用权限。',
    loading: '正在读取渠道配置…',
    loadFailed: '无法读取渠道配置，请重试。',
    saved: '使用渠道已更新',
    saveFailed: '保存失败，请确认应用编辑权限后重试。',
    allClosed: '所有平台均已关闭，用户将无法看到或使用此应用。已有安装、收藏和会话会保留。',
    cancel: '取消',
    save: '保存',
    saving: '保存中…',
    options: {
      web_standard: { label: '普通 Web', description: '通过密码或通用 SSO 登录的 Web 访问。' },
      web_wecom: { label: '企业微信', description: '通过企业微信免密登录的 Web 访问。' },
      im: { label: 'IM', description: '通过已接入的即时通信机器人使用应用。' },
    },
  },
  columnSelector: {
    label: '选择应用列表列',
    trigger: '列',
  },
  description: '查看企业内应用资产、生命周期、发布状态、可见范围和负责人信息。',
  empty: '暂无应用',
  emptyDescription: '无描述',
  deleteDialog: {
    cancel: '取消',
    close: '关闭删除确认',
    confirm: '确认删除',
    failed: '删除应用失败，请稍后重试。',
    message:
      '删除后「{{name}}」的应用配置、可见范围、接入配置、平台内使用统计和对话记录都会被移除。',
    subtitle: '删除后无法恢复！',
    success: '应用已删除',
    title: '删除应用？',
  },
  drawer: {
    avatarFallback: '新',
    cancel: '取消',
    confirm: '确定',
    configFields: {
      api_host: 'API 地址',
      api_key: 'API 密钥',
      app_key: 'ADP App Key',
      chat_base_url: 'ADP 对话端基础域名',
      credential_id: '腾讯 ADP 凭据',
      custom_params: '自定义参数',
      openapi_endpoint: 'ADP OpenAPI Endpoint',
      registered_model_id: 'Agent 模型',
      show_tool_invocation_details: '显示工具详情',
      show_process_details: '显示 ADP 过程详情',
      show_workflow_details: '显示工作流详情',
      system_prompt: '系统提示词',
      tencent_region: '腾讯云 Region',
      tencent_secret_id: '腾讯云 SecretId',
      tencent_secret_key: '腾讯云 SecretKey',
      url_template: '应用 URL 模板',
      websocket_endpoint: 'ADP WebSocket Endpoint',
    },
    configFieldHints: {
      show_tool_invocation_details:
        '关闭后，聊天中仍显示工具完成或失败状态，但不再提供输入和输出详情。',
    },
    createTitle: '新建应用',
    detailLoadFailed: '请稍后重试，或检查当前管理员是否仍有应用访问权限。',
    detailLoadFailedTitle: '应用详情加载失败',
    editTabs: {
      basic: '基础信息',
      config: '应用配置',
      configEmpty: '该应用类型暂无额外配置。',
      createdAt: '创建时间',
      label: '编辑应用页签',
      lifecycle: '生命周期',
      updatedAt: '更改时间',
    },
    editTitle: '编辑 / {{name}}',
    fields: {
      avatar: '应用图标',
      appConfig: '应用配置',
      appType: '应用类型',
      description: '应用描述',
      name: '应用名称',
      tags: '业务标签',
      version: '版本号',
    },
    feedback: {
      adpValidationFailed: 'ADP 应用测试失败',
      adpValidationPassed: 'ADP 应用测试通过',
      configValidationFailed: '配置校验失败',
      createSuccess: '应用创建成功',
      submitFailed: '保存失败',
      updateSuccess: '应用保存成功',
      validationFailed: '请先修正表单内容',
    },
    nameAvailability: {
      available: '名称可用',
      checking: '正在检查名称是否可用…',
      failed: '暂时无法检查名称，请稍后重试。',
    },
    hideSecret: '隐藏密钥',
    iconPicker: {
      cancel: '取消',
      change: '更换',
      chooseAnother: '重新选择图片',
      chooseFile: '选择图片',
      confirm: '使用此图标',
      cropFailed: '图片裁切失败，请换一张图片重试。',
      cropPreview: '应用图标裁切预览',
      horizontal: '水平位置',
      open: '选择应用图标',
      presetDescription: '选择一枚预制图标，后续仍可随时替换。',
      presetLoadFailed: '预制图标加载失败，请重试或改为上传图片。',
      presets: {
        career: '简历求职',
        coding: '编程开发',
        grading: '智能批阅',
        illustration: '插画创作',
        language: '语言学习',
        learning: '课程学习',
        meeting: '会议纪要',
        presentation: '数据演示',
        promotion: '宣传推广',
        prompt: '智能提示',
        questions: '灵感出题',
        writing: '文章写作',
      },
      tabs: {
        presets: '预制图标',
        upload: '上传并裁切',
      },
      tabsLabel: '应用图标来源',
      title: '选择应用图标',
      uploadDescription: '上传自己的图片，并通过缩放与位置调整完成方形裁切。',
      uploadReadFailed: '无法读取这张图片，请换一张图片重试。',
      vertical: '垂直位置',
      zoom: '缩放',
    },
    oidc: {
      bindingDescription:
        '从 IdP 的 Clients 中选择一个已有 Client。Client 的 Callback URL、凭据和 Scope 不在应用表单重复维护。',
      client: 'OIDC Client',
      clientActive: '已启用',
      clientInactive: '已停用',
      clientSelectionHint: '不选择表示该应用暂不启用 OIDC 免密登录。',
      clientsLoadFailed: 'OIDC Client 列表加载失败。',
      noClient: '不绑定 Client',
      selectedClientScopes: 'Scopes：{{scopes}}',
      title: 'OIDC 免密登录',
    },
    save: '保存',
    placeholders: {
      replaceSecret: '输入新密钥以替换',
      appType: '请选择应用类型',
      description: '例如：面向销售团队，提供客户问答、资料检索和跟进建议。',
      name: '请输入应用名称',
      secret: '请输入密钥',
      tags: '搜索或创建业务标签',
      tagsEmpty: '暂无可选标签',
      version: '请输入（示例：1.0.0）',
    },
    registeredModels: {
      empty: '暂无可选已注册模型',
      loadFailed: '已注册模型加载失败，请稍后重试。',
      loading: '正在加载已注册模型...',
      placeholder: '请选择已注册模型',
      unavailable: '当前已保存模型不可用',
    },
    adpCredentials: {
      empty: '暂无可选腾讯 ADP 凭据，请先在凭据管理中创建。',
      loadFailed: '腾讯 ADP 凭据加载失败，请稍后重试。',
      loading: '正在加载腾讯 ADP 凭据...',
      manageLink: '管理凭据',
      placeholder: '请选择腾讯 ADP 凭据',
      unavailable: '当前已保存凭据不可用',
    },
    adpValidation: {
      successDetail: '应用 ID：{{appId}}\n应用名称：{{name}}',
      successDetailWithoutAppId: '已连接到 ADP 应用。',
      successDetailWithoutName: '应用 ID：{{appId}}',
      testApp: '测试连接',
    },
    secretConfigured: '已配置密钥。留空将保留现有密钥。',
    showSecret: '显示输入的密钥',
    submitFailed: '保存失败，请稍后重试。',
    tags: {
      createOption: '创建标签“{{name}}”',
      noMatches: '没有匹配的标签',
      remove: '移除标签 {{name}}',
    },
    uploadAvatar: '上传应用头像',
    validation: {
      configInvalid: '{{label}}格式不正确',
      configRequired: '{{label}}不能为空',
      difyApiHost: 'API 地址需以 http:// 或 https:// 开头，并以 /v1 结尾',
      chatBaseUrl: 'ADP 对话端基础域名只填写到 /adp/v2，不要包含 /chat/conn 路径',
      nameRequired: '请输入应用名称',
      nameCheckFailed: '暂时无法确认应用名称是否可用，请稍后重试。',
      nameConflict: '该应用名称已被使用，请更换名称。',
      typeRequired: '请选择应用类型',
      urlProtocol: '{{label}}需以 http:// 或 https:// 开头',
      websocketUrl: '{{label}}需以 ws:// 或 wss:// 开头',
      versionInvalid: '版本号格式应为 1.0.0',
    },
    wizard: {
      appTypeDescriptions: {
        default: '根据所选类型生成后续配置字段。',
        adp: '通过 WebSocket 模式接入腾讯智能体开发平台。',
        dify: '接入 Dify 应用，需要填写 API 地址和 API 密钥。',
        embed_url: '通过 URL 模板挂载外部页面，适合已有系统入口。',
        self_agent: '使用 AI Hub 内置智能体运行时，需要绑定模型和提示词。',
      },
      basic: {
        versionHint: '留空时后端不保存版本号。',
      },
      config: {
        descriptionWithType: '填写 {{type}} 所需的连接信息。',
        empty: '该应用类型暂无额外配置，可继续下一步。',
      },
      create: '创建应用',
      distribution: {
        assignmentFailed: '部分成员分配失败，应用已回滚，请重试。',
        effectiveCount: '预计覆盖 {{count}} 人',
        modeDescription: '选择如何向已授权成员分发此应用。',
        modeTitle: '应用分发方式',
        modes: {
          automatic: {
            description: '发布后自动出现在已分配用户的“我的应用”中；用户仍可自行移除。',
            title: '统一添加给成员',
          },
          manual: {
            description: '应用在应用广场可见，由用户按需添加到“我的应用”。',
            title: '成员按需添加',
          },
        },
        scopeDescription: '可按部门批量分配，也可以补充或排除具体成员。',
        scopeTitle: '可见与分配范围',
      },
      headerDescription: '第 {{current}} / {{total}} 步',
      lifecycle: {
        options: {
          active: '保存后自动完成测试、申请发布和发布，适合已确认可直接上架的应用。',
          draft: '只保存应用配置，后续由管理员手动推进发布链路。',
          pending_publish: '保存后自动提交到发布复核，减少重复点击。',
          testing: '保存后进入测试中，适合快速验证配置。',
        },
        partialSubmitFailed: '应用已创建，但未能自动流转到{{status}}，请在上下架审核中继续处理。',
        targetDescription: '选择应用创建完成后停留的 lifecycle 状态。',
        targetLabel: '创建后状态',
        transitionComment: '创建应用时自动推进生命周期',
      },
      next: '下一步',
      previous: '上一步',
      progress: '第 {{current}} 步，共 {{total}} 步',
      progressLabel: '创建应用进度：第 {{current}} 步，共 {{total}} 步，{{step}}',
      steps: {
        basic: {
          description: '先确认用户能识别这个应用的基础信息。',
          title: '基础信息',
        },
        config: {
          description: '根据应用类型填写连接和运行配置。',
          title: '应用配置',
        },
        distribution: {
          description: '选择可访问应用的部门和成员。',
          title: '成员分配',
        },
        lifecycle: {
          description: '设置进入“我的应用”的方式和创建后状态。',
          title: '发布设置',
        },
        type: {
          description: '类型决定下一步需要填写哪些配置字段。',
          title: '应用类型',
        },
      },
    },
  },
  errorDescription: '请稍后重试，或检查当前管理员是否仍有访问权限。',
  errorDescriptionWithDetail: '后端返回：{{detail}}',
  errorTitle: '应用列表加载失败',
  filters: {
    allStatuses: '所有状态',
    allTypes: '所有应用类型',
    searchLabel: '搜索应用名称',
    searchPlaceholder: '搜索应用名称',
    statusLabel: '筛选应用状态',
    typeLabel: '筛选应用类型',
  },
  imDrawer: {
    appStatus: {
      description: '平台回调已验证，可以启用或停用当前 integration。',
      identityBlocked:
        '回调已验证，但新用户自动绑定尚未就绪；已有绑定仍会继续执行 Portal 授权检查。',
      identityUnknown: '回调已验证，但身份解析权限仍待真实平台确认。',
      title: '接入状态',
      verificationRequired: '保存配置并完成平台回调验证后才可启用。',
      wecom: {
        blocked: '所选身份源或绑定入口当前不可用，请按配置提示处理后再启用。',
        callbackBlocked: '请检查 Token、EncodingAESKey 和企业微信回调配置并重新验证。',
        identity: {
          identity_profile_selected: '请选择一个已启用的企业微信身份源。',
          profile_agent_accessible: '企业微信应用不可访问，请联系系统管理员检查 Agent ID 和权限。',
          profile_agent_active: '企业微信应用已停用，请联系系统管理员在企微后台启用。',
          profile_credential_valid: '身份源凭据不可用，请联系系统管理员重新测试连接。',
        },
        unknown: '请先测试所选身份源的连接，再启用当前接入。',
      },
    },
    behavior: {
      feishu: {
        description: '此策略由 Portal 执行，飞书后台无需重复配置。',
        groupWhitelistPlaceholder: '请输入飞书会话 ID，多个 ID 可用逗号或换行分隔',
        p2pWhitelistPlaceholder: '请输入飞书用户 open_id，多个 ID 可用逗号或换行分隔',
      },
      group: '群聊策略',
      groupWhitelist: '群聊白名单',
      p2p: '私信策略',
      p2pWhitelist: '私信白名单',
      wecom: {
        description: '此策略由 Portal 执行，企业微信后台无需重复配置。',
        groupWhitelistPlaceholder: '请输入企微群会话 ID，多个 ID 可用逗号或换行分隔',
        p2pWhitelistPlaceholder: '请输入企微 userid 或 open_userid，多个 ID 可用逗号或换行分隔',
      },
    },
    cancel: '取消',
    clear: '清除数据',
    credentials: {
      feishu: {
        appId: 'App ID',
        appIdPlaceholder: '请输入 cli_ 开头的 App ID',
        appSecret: 'App Secret',
        appSecretPlaceholder: '请输入 App Secret',
        encryptKey: 'Encrypt Key',
        generatedDescription: '以下值仅在创建后展示一次，请立即保存并配置到飞书后台。',
        generatedTitle: '保存一次性回调安全配置',
        secretHint: 'App Secret 留空会沿用已保存值。',
        verificationToken: 'Verification Token',
      },
      copyEncryptKey: '复制 Encrypt Key',
      copyVerificationToken: '复制 Verification Token',
      preservePlaceholder: '已保存，留空表示保留',
      savedSecret: '敏感配置已加密保存；留空会继续沿用。',
      title: '{{platform}}凭据',
      wecom: {
        agentId: 'Agent ID',
        agentIdPlaceholder: '请输入企业微信自建应用 Agent ID',
        appSecret: 'App Secret',
        appSecretPlaceholder: '请输入企业微信自建应用 Secret',
        corpId: 'Corp ID',
        corpIdPlaceholder: '请输入 ww 开头的企业 ID',
        encodingAesKey: 'EncodingAESKey',
        encodingAesKeyPlaceholder: '请输入企业微信 EncodingAESKey',
        secretHint: 'Token 与 EncodingAESKey 仅用于当前 Bot 的消息回调；已保存字段留空表示保留。',
        token: 'Token',
        tokenPlaceholder: '请输入企业微信 API 模式智能机器人 Token',
      },
    },
    deleteDialog: {
      cancel: '取消',
      close: '关闭确认',
      confirm: '清除',
      message: '清除后当前平台的 IM 配置、状态和策略都会被删除。',
      subtitle: '这个操作会调用后端删除接口，保存过的凭据无法恢复。',
      title: '清除 IM 配置？',
    },
    unsavedDialog: {
      continueEditing: '继续编辑',
      discard: '放弃修改',
      message: '当前平台的配置尚未保存。你可以先保存，再切换平台或关闭抽屉。',
      save: '保存并继续',
      subtitle: '直接放弃会丢失本次输入，但不会影响已经保存的配置。',
      title: '处理未保存的 IM 配置',
    },
    errors: {
      deleteFailed: '清除 IM 配置失败，请稍后重试。',
      detailFailed: '请稍后重试，或检查当前管理员是否仍有应用访问权限。',
      detailFailedTitle: 'IM 配置加载失败',
      loadFailed: '请稍后重试，或检查当前管理员是否仍有应用访问权限。',
      loadFailedTitle: 'IM 平台列表加载失败',
      saveFailed: '保存 IM 配置失败，请稍后重试。',
      copyFailed: '复制 Callback URL 失败，请手动复制。',
      manifestFailed: '接入信息加载失败，请稍后重试。',
      statusFailed: '更新 IM 启用状态失败，请稍后重试。',
      validateFailed: '校验 IM 配置失败，请稍后重试。',
      verificationFailed: '刷新回调验证状态失败，请稍后重试。',
    },
    feedback: {
      clearSuccess: 'IM 配置已清除',
      copySuccess: 'Callback URL 已复制',
      disableSuccess: 'IM 已停用',
      enableSuccess: 'IM 已启用',
      saveSuccess: 'IM 配置已保存',
    },
    modes: {
      disabled: '禁用',
      open: '开放',
      whitelist: '白名单',
    },
    platformConfiguredDescription: '已存在配置，可继续编辑。',
    platformUnavailableDescription: '当前版本暂不支持该平台。',
    platformUnconfiguredDescription: '未配置，可立即开始接入。',
    platforms: {
      dingtalk: {
        name: '钉钉',
      },
      feishu: {
        name: '飞书',
      },
      wecom: {
        name: '企业微信',
      },
    },
    save: '保存',
    sections: {
      behavior: '消息接入策略（Portal）',
      dataConfig: '应用数据配置',
      statusAndGuide: '应用状态及接入说明',
      wecomSecurity: '回调安全配置',
      wecomIdentityProfile: '企业微信身份源',
    },
    setupGuide: {
      callbackUrl: 'Callback URL',
      copyCallback: '复制 Callback URL',
      feishu: {
        description:
          '将 Callback URL 配置到飞书应用事件订阅，并使用当前 integration 的验证配置完成校验。',
      },
      loading: '正在加载 Callback URL…',
      saveFirst: '保存当前平台配置后生成 Callback URL。',
      wecom: {
        botId: '智能机器人 ID',
        botIdUnknown: '尚未识别',
        description: '将 Callback URL、Token 和 EncodingAESKey 配置到企业微信 API 模式智能机器人。',
      },
    },
    status: {
      active: '已启用',
      comingSoon: '敬请期待',
      disabled: '已停用',
      draft: '未启用',
      unconfigured: '未配置',
    },
    title: 'IM 对接',
    titleWithName: 'IM 对接 / {{name}}',
    unsupportedAppType: '当前仅开放 Dify 与腾讯 ADP 应用接入 IM。',
    validate: '校验配置',
    validation: {
      failed: '配置校验发现问题，请先处理。',
      passed: '配置校验通过。',
    },
    readiness: {
      actions: {
        aggregate: {
          blocked: '请先处理上方身份源或回调阻塞项，再启用当前 integration。',
          unknown: '当前可启用 Bot 完成首次真实用户授权；授权成功并刷新状态前仍非完全就绪。',
        },
        callback: {
          blocked: '请检查 Token、EncodingAESKey 与企业微信回调配置，并重新完成验证。',
          unknown: '请保存回调配置后，在企业微信完成回调验证并刷新状态。',
        },
        profile: {
          blocked: '请联系系统管理员检查身份源凭据、通讯录权限和数据可见范围。',
          unknown: '需要一次真实用户扫码授权确认企业邮箱权限与数据范围；当前状态仍非完全就绪。',
        },
      },
      aggregate: '整体 readiness',
      callback: 'Callback readiness',
      loading: '检查中',
      profile: '身份源 readiness',
      status: {
        blocked: '阻塞',
        ready: '就绪',
        unknown: '待确认',
      },
    },
    wecomProfile: {
      activeReadonly: '当前 integration 已启用；停用后才能更换身份源。',
      available: '连接可用',
      description: '选择当前 Bot 使用的企业微信身份源。应用访问权限仍由 Portal 独立检查。',
      emptyAppAdmin: '当前没有可用身份源，请联系系统管理员配置。',
      emptySystemAdmin: '当前没有可用身份源，请先创建并启用身份源。',
      field: '企业微信身份源',
      loadFailed: '企业微信身份源加载失败，请稍后重试。',
      manage: '管理身份源',
      placeholder: '请选择身份源',
      title: '身份源选择',
      unavailable: '当前身份源不可用，请联系系统管理员检查配置。',
    },
    identityReadiness: {
      actions: {
        directory_scope_configured: '请将需要使用 Bot 的成员加入应用通讯录可见范围。',
        email_field_permitted: '请为 Bot 应用开通读取企业邮箱字段的权限。',
        identity_connector_supported: '当前 connector 尚不支持可信企业邮箱解析。',
        profile_api_accessible: '请允许 Bot 应用调用平台用户资料 API。',
        profile_credential_valid: '请配置可用于用户资料查询的有效 Bot 应用凭据。',
      },
      checks: {
        directory_scope_configured: '通讯录数据范围',
        email_field_permitted: '企业邮箱字段权限',
        identity_connector_supported: '身份解析 connector',
        profile_api_accessible: '用户资料 API',
        profile_credential_valid: 'Bot 应用凭据',
      },
      description: {
        blocked: '自动绑定条件不完整，首次未绑定用户不会进入 Runtime。',
        ready: '首次未绑定用户可以通过可信企业邮箱自动匹配 Portal 账号。',
        unknown: '尚未通过真实平台用户资料查询确认全部权限与数据范围。',
      },
      loading: '检查中',
      status: {
        blocked: '未就绪',
        ready: '已就绪',
        unknown: '待确认',
      },
      title: '身份解析 readiness',
      unknown: {
        directory_scope_configured: '待真实用户资料查询确认。',
        email_field_permitted: '待真实用户资料查询确认。',
        identity_connector_supported: '待 connector 能力确认。',
        profile_api_accessible: '待真实平台请求确认。',
        profile_credential_valid: '待平台凭据请求确认。',
      },
    },
    verification: {
      lastVerified: '最近验证：{{time}}',
      neverVerified: '尚未完成验证',
      refresh: '刷新验证状态',
      status: {
        failed: '验证失败',
        stale: '凭据已变更，需要重新验证',
        unverified: '未验证',
        verified: '已验证',
        verifying: '验证中',
      },
      title: '回调验证',
    },
  },
  membersDrawer: {
    badges: {
      direct: '直绑',
      excluded: '已排除',
      inherited: '继承',
    },
    cancel: '取消',
    companyLabel: '选择公司',
    companyLoading: '公司加载中',
    discardDialog: {
      cancel: '继续编辑',
      close: '关闭提示',
      confirm: '放弃并关闭',
      message: '关闭抽屉后，当前成员和部门权限调整都会丢失。',
      subtitle: '成员权限变更尚未保存。请先保存，或确认放弃当前调整。',
      title: '放弃未保存的更改？',
    },
    loadFailedDescription: '请稍后重试，或检查当前管理员是否仍有应用成员管理权限。',
    loadFailedTitle: '成员权限加载失败',
    members: {
      deselectPage: '取消本页',
      emptyScope: '当前范围没有成员',
      loadFailedDescription: '请稍后重试，或检查当前管理员是否仍有组织成员读取权限。',
      loadFailedTitle: '成员列表加载失败',
      noEmail: '无邮箱',
      noSearchResults: '没有匹配的成员',
      pageStatus: '第 {{page}} / {{total}} 页',
      searchLabel: '搜索成员',
      searchPlaceholder: '搜索成员姓名或邮箱',
      selectPage: '全选本页',
      selectDepartment: '请选择部门',
      scopeCount: '{{count}} 人',
      selectMember: '授权成员 {{name}}',
      unselectMember: '取消授权成员 {{name}}',
    },
    save: '保存',
    saveFailed: '保存成员权限失败，请稍后重试。',
    partialSaveFailed: '{{count}} 个账号未保存，请稍后重试。',
    partialSaveFailedTitle: '成员权限部分保存失败',
    saveSuccess: '成员权限已保存',
    saving: '保存中',
    scopeTitle: '应用可见范围',
    selected: {
      departmentsTab: '部门 {{count}}',
      membersTab: '成员 {{count}}',
      noDepartments: '暂无授权部门',
      noMembers: '暂无直绑成员',
      tabsLabel: '切换已选权限类型',
      title: '权限配置',
    },
    summary: {
      departments: '授权部门 {{count}}',
      directMembers: '直绑成员 {{count}}',
      effectiveMembers: '可访问成员 {{count}}',
    },
    title: '成员管理',
    titleWithName: '成员管理 / {{name}}',
    tree: {
      bindDepartment: '授权部门 {{name}}',
      collapse: '收起 {{name}}',
      expand: '展开 {{name}}',
      noResults: '没有匹配的部门',
      searchLabel: '搜索部门',
      searchPlaceholder: '搜索部门',
      sortAsc: '升序',
      sortDesc: '降序',
      title: '部门选择',
      unbindDepartment: '取消授权部门 {{name}}',
    },
  },
  review: {
    actions: {
      approve_for_testing: '进入测试',
      ban: '下架',
      open: '打开 {{name}} 的上下架操作菜单',
      process: '处理审核',
      publish: '发布',
      republish: '重新发布',
      request_publish: '申请发布',
      return_to_draft: '退回草稿',
      return_to_testing: '退回测试',
      unpublish: '直接下架',
      viewHistory: '查看记录',
    },
    changeTypes: {
      active: '下架管理',
      banned: '重新上架',
      draft: '提交测试',
      pending_publish: '发布复核',
      testing: '发布申请',
    },
    columnSelector: {
      label: '选择上下架审核列表列',
      trigger: '列',
    },
    description: '处理应用发布、下架和状态复核，确保市场内容可控。',
    directUnpublish: {
      cancel: '取消',
      close: '关闭下架确认',
      commentHint: '选填，建议记录下架原因，方便后续追踪。',
      commentLabel: '下架原因',
      commentPlaceholder: '请输入下架原因',
      confirm: '下架',
      description: '下架后应用会从可用市场中移除，已有配置与历史记录保留。',
      success: '应用已下架',
      submitFailed: '下架失败，请稍后重试。',
      submitFailedWithDetail: '下架失败：{{detail}}',
      subtitle: '{{name}} 将直接变为已停用状态。',
      title: '下架应用？',
    },
    drawer: {
      actionsLoadFailed: '可用操作加载失败，请稍后重试。',
      activeDirectTip: '已发布应用从列表操作菜单直接下架，这里只保留流转记录。',
      availableActions: '可用操作',
      availableActionsDescription: '操作由后端 lifecycle contract 返回，前端只负责展示和提交。',
      bannedOutsideFlow: '已停用不属于发布链路中的正常阶段，可重新发布或退回草稿。',
      close: '关闭',
      commentHint: '选填，会写入状态流转记录。',
      commentLabel: '处理备注',
      commentPlaceholder: '请输入处理备注',
      history: '流转记录',
      historyEmpty: '暂无流转记录',
      historyLoadFailed: '流转记录加载失败，请稍后重试。',
      noActions: '当前状态暂无可执行操作。',
      noDescription: '无描述',
      progressLabel: '应用发布状态流转',
      submit: '选择操作',
      submitFailed: '状态更新失败，请稍后重试。',
      submitFailedWithDetail: '状态更新失败：{{detail}}',
      title: '上下架处理',
      titleWithName: '上下架处理 / {{name}}',
      transitionSuccess: '状态已更新',
      unknownOperator: '未知操作人',
    },
    empty: '暂无待处理应用',
    errorDescription: '请稍后重试，或检查当前管理员是否仍有访问权限。',
    errorTitle: '上下架列表加载失败',
    table: {
      actions: '操作',
      app: '应用',
      appType: '应用类型',
      changeType: '变更类型',
      status: '状态',
      updatedAt: '更新时间',
      version: '版本',
    },
    title: '上下架审核',
    workspaceLabel: '上下架审核工作区',
  },
  pagination: {
    next: '下一页',
    pageSize: '{{count}} 条/页',
    previous: '上一页',
  },
  retry: '重试',
  status: {
    active: '活跃',
    banned: '已停用',
    draft: '草稿',
    pending_publish: '待发布',
    testing: '测试中',
  },
  sort: {
    createdAtAsc: '按创建时间升序排列',
    createdAtDesc: '按创建时间降序排列',
    updatedAtAsc: '按更新时间升序排列',
    updatedAtDesc: '按更新时间降序排列',
  },
  table: {
    actions: '操作',
    createdAt: '创建时间',
    description: '应用描述',
    name: '应用',
    status: '状态',
    type: '应用类型',
    updatedAt: '更改时间',
    version: '应用版本',
  },
  title: '应用管理',
  workspaceLabel: '应用管理工作区',
}

export default adminApps
